import {createSlice} from "@reduxjs/toolkit";

export type NotificationState = {
    modal: ModalType;
};

type ModalType = {
    show?: boolean;
    type: "success" | "error";
    title: string;
    body: string;
    onClose?: () => void
};

const initialState: NotificationState = {
    modal: {} as ModalType,
};

const slice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        openModal(state, {payload}: { payload: ModalType }) {
            state.modal.type = payload.type;
            state.modal.title = payload.title;
            state.modal.body = payload.body;
            state.modal.show = true;
            state.modal.onClose = payload.onClose
            console.log(state.modal);
        },
        closeModal(state) {
            state.modal = initialState.modal;
            state.modal.show = false;
        },
        reset: () => ({...initialState})
    },
});

export const notification = {
    reducer: slice.reducer,
    mutation: slice.actions,
};
